jQuery(document).ready(function($) {
    $('#ajax-search').on('keyup', function() {
        var maxCharacters = ajax_search_params.max_characters;
        var query = $(this).val();
        if (maxCharacters > 0 && query.length > maxCharacters) {
            query = query.substring(0, maxCharacters);
            $(this).val(query);
        }
        if (query.length > 2) {  // Trigger after 3 characters
            $('#loading-spinner').show(); // Show loading spinner
            $.ajax({
                url: ajax_search_params.ajax_url,
                method: 'GET',
                data: {
                    action: 'ajax_search',
                    s: query,
                    lang: ajax_search_params.lang,
                },
                success: function(response) {
                    $('#loading-spinner').hide(); // Hide loading spinner
                    $('.popular-pages').hide(); // Hide popular pages
                    $('#search-results').html(response); // Display search results
                },
            });
        } else {
            $('#loading-spinner').hide(); // Hide spinner if query is empty or too short
            $('#search-results').html(''); // Clear results
        }
    });
});

